import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import LinkIcon from "../../assets/Link.png"
// 🔹 Modal common style
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 320,
  bgcolor: "#fff",
  borderRadius: "14px",
  boxShadow: 24,
  p: 3,
  textAlign: "center",
};

const UnlinkWalletModal = (props) => {
  const {
    unlinkModal,
    setUnlinkModal,
    requestsumbitted,
    setRequestsumbitted,
    BpUnlink,

  } = props;

  return (
    <>
      {/* ================= UNLINK CONFIRMATION MODAL ================= */}
      <Modal
        open={unlinkModal}
        onClose={() => setUnlinkModal(false)}
      >
        <Box sx={modalStyle}>
            <Box display={"flex"} justifyContent= {"center"}>
          <img
            src={LinkIcon}
            alt="unlink"
            style={{
              width: "105px",
              marginTop: "-70px",
            }}
          />
          </Box>

          <Typography
            sx={{
              mt: 1,
              color: "#384F6F",
              fontSize: "14px",
              fontWeight: 700,
              letterSpacing: "1px",
            }}
          >
            Request to Unlink Business Wallet
          </Typography>

          <Typography
            sx={{
              mt: 1,
              color: "rgba(56, 79, 111, 0.69)",
              fontSize: "12px",
              lineHeight: "17.5px",
            }}
          >
            Send request for admin to unlink your business wallet from the
            account.
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mt: 3,
            }}
          >
            <Button
              variant="contained"
              onClick={() => setUnlinkModal(false)}
              sx={{
                width: "128px",
                height: "41px",
                fontWeight: 800,
                backgroundColor: "#9E9E9E",
                "&:hover": {
                  backgroundColor: "#757575",
                },
              }}
            >
              No
            </Button>

            <Button
              variant="contained"
              onClick={BpUnlink}
              sx={{
                width: "130px",
                height: "41px",
                fontWeight: 800,
                backgroundColor: "#D32F2F",
                "&:hover": {
                  backgroundColor: "#B71C1C",
                },
              }}
            >
              Yes
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* ================= REQUEST SUBMITTED MODAL ================= */}
      <Modal
        open={requestsumbitted}
        onClose={() => setRequestsumbitted(false)}
      >
        <Box sx={modalStyle}>
          <Box display={"flex"} justifyContent= {"center"}>
          <img
            src={LinkIcon}
            alt="unlink"
            style={{
              width: "105px",
              marginTop: "-70px",
            }}
          />
          </Box>

          <Typography
            sx={{
              mt: 1,
              fontWeight: 700,
              fontSize: "15px",
              color: "#384F6F",
            }}
          >
            Request Already Submitted
          </Typography>

          <Typography
            sx={{
              mt: 1,
              fontSize: "13px",
              color: "#555",
            }}
          >
            Your unlinking request has been received. Please wait for admin
            approval.
          </Typography>

          <Button
            variant="contained"
            onClick={() => setRequestsumbitted(false)}
            sx={{
              mt: 3,
              width: "120px",
              height: "40px",
              fontWeight: 700,
      background:"#00B177",
            }}
          >
            OK
          </Button>
        </Box>
      </Modal>
    </>
  );
};

export default UnlinkWalletModal;
